import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import "../../assets/styles/_alert_notifications.scss"
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import AlertTabs from '../components/AlertTabs';
import { trackActivity } from '../../../utils/mixpanel';
import CustomAlerts from './customAlerts';
import ExpiryAlerts from './ExpiryAlerts';
import EventAlerts from './EventAlerts';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import AccessDeniedMessage from '../../elements/AccessDeniedMessage';

const AlertNotification = () => {
  const { leaseBasicDetails, permission } = useSelector((state) => state.leases);
  const leaseRevampPermissions = permission?.permissions?.lease_revamp_application?.lease_revamp;
  const hasAnyAlertPermission = ['alert_n_notification', 'expiry_alert', 'custom_alert'].some(feature =>
    leaseRevampPermissions?.[feature]?.includes('R')
  );
  const [activeTab, setActiveTab] = useState("event");
  const [compactActionBar, setCompactActionBar] = useState(null);

  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Alert & Notifications' })
  }, [])

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Alert & Notifications`, page_type: page_type, })
  }
  const onChangeTab = (value) => {
    setActiveTab(value);
    setCompactActionBar(null);
    handleItemClicked(`Clicked on ${value === 'event' ? 'Event' : value === 'expiry' ? 'Expiry' : 'Custom'} Alert(s) tab`)
  }

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        {!hasAnyAlertPermission ? (
        <div className='lease-details-content'>
          <AccessDeniedMessage />
        </div>
        ) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
        <div className='lease-details-content'>
          <Paper square className="responsive-paper">
            <Grid container rowSpacing={0} columnSpacing={1} className="responsive-grid" alignItems='flex-end'>
              <Grid size={{ md: 12 }}>
                <AlertTabs value={activeTab} onChangeTab={(e, value) => onChangeTab(value)} />
              </Grid>
              <Grid item size={{ md: 4, xs: 12 }} className="menu-container lease-list-link-mt">
                <BackToLeaseList/>
              </Grid>
              {compactActionBar && (
                <Grid item size={{ md: 8, xs: 12 }}>
                  {compactActionBar}
                </Grid>
              )}
            </Grid>
          </Paper>
          {activeTab === "event" && (
            <EventAlerts />
          )}

          {activeTab === "expiry" && (
            <ExpiryAlerts setActionBar={setCompactActionBar} />
          )}

          {activeTab === "custom" && (
            <CustomAlerts setActionBar={setCompactActionBar} />
          )}
        </div>}
      </Paper>
    </>
  )
}

export default AlertNotification;
